import { makeStyles, Paper } from "@material-ui/core";
import StepContainer from "components/request-document/StepContainer";
import { SMART_T_STEP } from "libs/constant/Step";
import AdminButtonController from "pages/admin/smart-visa/AdminButtonController";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getAllDocumentsList, setDocDetail } from "redux/modules/allDocumentsSlice";
import { getPersonalDetail } from "redux/modules/personalSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import { getSmartForm, setSmartFormSetDraftId, setSmartServiceId } from "redux/modules/visaForm";
import {
  STATUS_PROCESS,
} from "libs/configs/constant";
import useAdminModalLoading from "libs/hooks/useAdminModalLoading";
const useStyles = makeStyles((theme) => ({
  paper: {
    flexDirection: "column",
    flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
    // marginBottom: 60
  },
  wrapBtnControl: {
    width: "100%", bottom: 0, backgroundColor: "white", zIndex: 1, border: "1px solid rgba(0, 0, 0, 0.12)", borderRadius: "10px", borderLeftWidth: "1px", borderRightWidth: "1px", padding: "15px",
    position: "sticky", marginTop: "30px"
  }
}));

function DocumentDetailPage() {
  const classes = useStyles();
  let { draftId } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoadind] = useState(false);

  const { showAdminLoading, hideAdminLoading } = useAdminModalLoading();
  const { profile } = useSelector(
    (state) => state.user
  );
  const { configApprveSmartFrom } = useSelector(
    (state) => state.allDocuments.detail
  );

  const departmentApprove = () => {
    const depapprove = configApprveSmartFrom?.find(x => x.departmentId === profile.departmentId);
    return depapprove;
  }



  useEffect(async () => {
    async function fetchData() {
      dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_PASSPORT));
      dispatch(setSmartFormSetDraftId(draftId))
      const res = await dispatch(getAllDocumentsList({ draftId }));
      if (res.payload && res.payload.length > 0) {
        const detail = res.payload[0];
        await dispatch(getPersonalDetail({ personalId: detail.personalId }))
        dispatch(setSmartServiceId(detail.smartserviceId));

        console.log(detail);
        const depapprove = detail?.configApprveSmartFrom?.find(x => x.departmentId === profile.departmentId);


        if (depapprove?.statusProcessId === STATUS_PROCESS.UploadAddDoc || depapprove?.statusProcessId === STATUS_PROCESS.RequestAddDoc) {
          dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
        }
        else if (detail?.statusProcessId === STATUS_PROCESS.ReviewingHealthInsurance) {
          console.log('SMART_T_STEP.HEALTH_INSUANCE');
          dispatch(setSmartFormStep(SMART_T_STEP.HEALTH_INSUANCE));
        }
        else {
          dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_PASSPORT));
        }

        await dispatch(
          getSmartForm({
            // personalId: detail.personalId,
            smartserviceId: detail.smartserviceId,
            draftId: detail.draftId,
          })

        );

        dispatch(setDocDetail(detail));
      }
    }

    showAdminLoading();
    await fetchData();
    setLoadind(true);
    hideAdminLoading();
  }, [dispatch, draftId]);

  return (

    <Paper className={classes.paper} id="admin-view">
      {
        loading &&
        <>
          <StepContainer />
          <div className={classes.wrapBtnControl}>
            <AdminButtonController />
          </div>
        </>
      }

      {/* <div className={classes.wrapBtnControl}>
        test
      </div> */}




    </Paper>
  );
}

export default DocumentDetailPage;

